import { useEffect } from "react";

import { useI18n } from "@/contexts/i18nContext";

import { setChartJsLocale } from "./base";

const RegisterChartLocale = () => {
  const { locale } = useI18n();

  // Setup the chart language adapter defaults
  useEffect(() => {
    if (locale) {
      setChartJsLocale(locale);
    }
  }, [locale]);

  return null;
};

export default RegisterChartLocale;
